import { ElementWithProps, createComponent } from '@carvana/merch-components';

export const DesktopEllipseImg = createComponent<
  ElementWithProps<object, HTMLImageElement>
>('img', () => ({
  alt: '',
  'aria-hidden': true,
  className: 'absolute select-none top-[200px]'
}));

export const TabletImg = createComponent<
  ElementWithProps<object, HTMLImageElement>
>('img', () => ({
  className:
    'absolute -translate-y-1/2 max-w-none select-none top-1/2 h-full left-[47vw]'
}));

export const DesktopEllipse = createComponent<ElementWithProps>('div', {
  className:
    'absolute h-[960px] top-[-201px] w-[960px] [mask-image:var(--desktop-ellipse-mask)] [mask-repeat:no-repeat] [mask-size:100%_100%]'
});
